<template>
  <div id="login">
    <div class="container">
      <div class="loginBox">
        <div class="logo">
          <span class="logo-icon"></span>
        </div>
        <a-form id="components-form-demo-normal-login" :form="form" class="login-form">
          <div class="error-tips" v-if="tips.length > 0">{{ tips }}</div>
          <a-form-item>
            <a-input
              v-decorator="[
                'mobile',
                {
                  rules: [{ required: true, message: '请输入帐号!' }],
                },
              ]"
              placeholder="请输入帐号"
            >
              <span class="user-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              @change="passwordChange"
              v-decorator="[
                'password',
                {
                  rules: [{ required: true, message: '请输入密码!' }],
                },
              ]"
              :type="exe ? 'text' : 'password'"
              placeholder="请输入密码"
            >
              <span @click="exe = !exe" :class="[exe ? `exe_open` : `exe_close`]" slot="suffix" type="user" />
              <span class="pwd-icon" slot="prefix"></span>
            </a-input>
          </a-form-item>
          <div class="reg-box">
            <span><router-link :to="{ name: 'register' }">注册账号</router-link> </span>
            <span><router-link :to="{ name: 'resetPassword' }">忘记密码</router-link> </span>
          </div>
          <a-form-item style="margin-bottom: 30px">
            <a-checkbox
              v-decorator="[
                'agree',
                {
                  valuePropName: 'checked',
                  initialValue: choose,
                },
              ]"
            >
              <span class="agreement" style="">
                本人确认已仔细阅读并充分理解
                <router-link to="/agreement?id=1">《用户协议》</router-link>
                、<router-link to="/agreement?id=2">《隐私协议》</router-link> 与<router-link to="/agreement?id=5"
                  >《美术作品合作协议》</router-link
                >
                的全部内容，同意接受上述协议的全部内容</span
              >
            </a-checkbox>
            <!-- <a class="login-form-forgot" href="">
            Forgot password
          </a> -->

            <!-- Or
          <a href="">
            register now!
          </a> -->
          </a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="login-form-button"
            style="width: 100%; height: 50px; border-radius: 8px"
            :loading="loading"
            @click="handleSubmit"
          >
            登录
          </a-button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import { _debounce } from '../../utils/util'
export default {
  transition: 'fade',
  components: {},
  data () {
    return {
      choose: false,
      exe: false,
      tips: '',
      loading: false
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'normal_login' })
  },
  mounted () {
    this.burry('2')
    // console.log(this.$axios.defaults.baseURL)
    if (localStorage.getItem('isFirstLogin')) {
      this.choose = true
    }
  },
  methods: {
    ...mapActions(['handleLogin']),
    handleSubmit: _debounce(function (e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!values.agree) {
          this.$message.error('请先勾选确认用户条款')
          return
        }
        if (!err) {
          const params = {
            mobile: values.mobile,
            password: values.password
          }
          this.loading = true
          // 调用登录接口
          const res = await this.handleLogin(params)

          this.loading = false
          console.log(res)
          if (res.status === 'error') {
            if (res.message.key === 1007) {
              this.tips = '*账号或密码不正确'
            }
            return false
          }
          this.burry('3')
          localStorage.setItem('isFirstLogin', '1')
          // 调取store里的user.js的GetInfo方法,拿到用户信息res
          this.$store.dispatch('GetInfo').then(res => {
            console.log(res)

            if (res.authentication_status == 2) { // 用户认证状态 @0:未认证 @1:认证中 @2：认证成功 @3:认证失败
              if (this.$route.query.redirect) {
                console.log(this.$route.query.redirect)
                this.$router.replace({ path: this.$route.query.redirect })
              } else {
                this.$router.replace({ path: '/manage/chartlet' })
              }
            } else {
              this.$router.replace({ path: '/manage/materialDirection' })
            }
          })
        }
      })
    }, 200),
    passwordChange (e) {
      if (e.target.value === '') {
        this.tips = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
#components-form-demo-normal-login .login-form {
  max-width: 300px;
}
#components-form-demo-normal-login .login-form-forgot {
  float: right;
}
#components-form-demo-normal-login .login-form-button {
  width: 100%;
}
#login {
  position: relative;
  width: 100%;
  min-height: 100%;
  background: url(../../assets/img/bg.jpg) no-repeat;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position-y: 1px;
}

.container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: relative;
  width: 100%;
  .loginBox {
    width: 460px;
    padding-bottom: 50px;
    background-color: #ffffff;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    text-align: center;
    border-radius: 20px;
    /deep/ .ant-form-item-control-wrapper {
      .ant-form-item-children {
        padding-left: 0px;
      }
    }
    /deep/ .ant-input-affix-wrapper .ant-input {
      height: 42px;
      border-radius: 8px;
    }
    h1 {
      margin-bottom: 60px;
    }
    /deep/ .ant-form-explain {
      text-align: left;
    }
    /deep/ .ant-checkbox + span {
      display: inline-block;
      vertical-align: -6px;
    }
    .agreement {
      font-size: 12px;
      color: #999999;
      width: 278px;
      display: inline-block;
      line-height: 24px;
      vertical-align: top;
      text-align: left;
    }
    .logo {
      width: 200px;
      height: 70px;
      margin-bottom: 40px;
      background-color: @primary-color;
      border-radius: 0px 0px 20px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        display: block;
        width: 142px;
        height: 25px;
      }
    }
    .reg-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 25px;
      a {
        color: inherit;
      }
      span {
        font-size: 14px;
        cursor: pointer;
        &:hover {
          color: @primary-color;
        }
      }
    }
    .login-form {
      width: 320px;
      .error-tips {
        color: #f5222d;
        text-align: left;
        margin-bottom: 12px;
      }
      /deep/ .ant-checkbox-checked .ant-checkbox-inner {
        background: none;
      }
      /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
        border-color: @primary-color;
      }
    }
  }
}

.title {
  font-family: 'Quicksand', 'Source Sans Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue',
    Arial, sans-serif;
  display: block;
  font-weight: 300;
  font-size: 100px;
  color: #35495e;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 42px;
  color: #526488;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.links {
  padding-top: 15px;
}
</style>
